import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useBottomSheetStore } from '@/store/bottomSheet';
import { computed } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'BottomSheet',
  setup(__props) {

const bottomSheetStore = useBottomSheetStore();

const model = computed({
  get: () => bottomSheetStore.isOpen,
  set: (val) => {
    if (!val) bottomSheetStore.closeSheet();
  }
});

const cancel = () => {
  bottomSheetStore.closeSheet();
};

const confirm = async () => {
  const { action, item } = bottomSheetStore.props || {};
  if (action && item) {
    try {
      await action(item);
    } catch (e) {
      console.error('Error ejecutando acción en BottomSheet:', e);
    }
  }
  bottomSheetStore.closeSheet();
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_bottom_sheet = _resolveComponent("v-bottom-sheet")!

  return (_openBlock(), _createBlock(_component_v_bottom_sheet, {
    modelValue: model.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
    inset: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "text-center pa-4 pb-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, {
            class: "text-h6",
            style: {"text-transform":"capitalize"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(bottomSheetStore).formTitle), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                text: "",
                onClick: cancel
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("Cancelar")
                ])),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                color: "error",
                onClick: confirm
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("Confirmar")
                ])),
                _: 1
              }),
              _createVNode(_component_v_spacer)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})